<template>
  <div class="row">
    <div class="col">
      <span v-if="!stats"><i class="fa fa-circle-o-notch fa-spin" /></span><span v-else>
        {{ stats.leads.active | number(0) }} /

        {{ stats.leads.total | number(0) }}</span>
    </div>
    <div class="col">
      <span v-if="!stats"><i class="fa fa-circle-o-notch fa-spin" /></span><span v-else>
        {{ stats.actions.mail.delivered | number(0) }} /

        {{ stats.actions.mail.opened | number(0) }} /

        {{ stats.actions.mail.clicked | number(0) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id'],

  data () {
    return {
      stats: null,
    };
  },

  created () {
    this.getStats();
  },

  methods: {
    getStats () {
      this.$http.get(`/automation/${this.id}/stats`)
        .then(({ data: stats }) => {
          this.stats = stats;
        });
    },
  },
};
</script>
